module.exports = __webpack_public_path__ + "img/poster-2.1d14e356.jpg";